import { useSplitTreatments } from "@splitsoftware/splitio-react";
import { FeatureFlags } from "./FeatureFlags";

export function useFeatureEnabled(feature: FeatureFlags) {
  const { treatments } = useSplitTreatments({ names: [feature] });

  return treatments[feature].treatment === "on";
}
